/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _remove_participant_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Retirer le participant' }],
    'fr',
);

const _remove_participant_en = new IntlMessageFormat(
    [{ type: 0, value: 'Remove participant' }],
    'en',
);

export function remove_participant(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _remove_participant_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _remove_participant_en.format(args) as unknown as string;
    }

    return _remove_participant_fr.format(args) as unknown as string;
}

const _new_discussion_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Nouvelle discussion' }],
    'fr',
);

const _new_discussion_en = new IntlMessageFormat(
    [{ type: 0, value: 'New discussion' }],
    'en',
);

export function new_discussion(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _new_discussion_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _new_discussion_en.format(args) as unknown as string;
    }

    return _new_discussion_fr.format(args) as unknown as string;
}

const _inbox_title_fr = new IntlMessageFormat([{ type: 0, value: 'Messagerie' }], 'fr');

const _inbox_title_en = new IntlMessageFormat([{ type: 0, value: 'Inbox' }], 'en');

export function inbox_title(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _inbox_title_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _inbox_title_en.format(args) as unknown as string;
    }

    return _inbox_title_fr.format(args) as unknown as string;
}

const _filter_not_read_fr = new IntlMessageFormat([{ type: 0, value: 'Non lues' }], 'fr');

const _filter_not_read_en = new IntlMessageFormat([{ type: 0, value: 'Unread' }], 'en');

export function filter_not_read(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _filter_not_read_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _filter_not_read_en.format(args) as unknown as string;
    }

    return _filter_not_read_fr.format(args) as unknown as string;
}

const _filter_groups_fr = new IntlMessageFormat([{ type: 0, value: 'Groupes' }], 'fr');

const _filter_groups_en = new IntlMessageFormat([{ type: 0, value: 'Groups' }], 'en');

export function filter_groups(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _filter_groups_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _filter_groups_en.format(args) as unknown as string;
    }

    return _filter_groups_fr.format(args) as unknown as string;
}

const _search_in_thread_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Rechercher dans la discussion' }],
    'fr',
);

const _search_in_thread_en = new IntlMessageFormat(
    [{ type: 0, value: 'Search in the discussion' }],
    'en',
);

export function search_in_thread(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _search_in_thread_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _search_in_thread_en.format(args) as unknown as string;
    }

    return _search_in_thread_fr.format(args) as unknown as string;
}

const _mark_as_read_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Marquer comme lu' }],
    'fr',
);

const _mark_as_read_en = new IntlMessageFormat(
    [{ type: 0, value: 'Mark as read' }],
    'en',
);

export function mark_as_read(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _mark_as_read_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _mark_as_read_en.format(args) as unknown as string;
    }

    return _mark_as_read_fr.format(args) as unknown as string;
}

const _mark_as_unread_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Marquer comme non lu' }],
    'fr',
);

const _mark_as_unread_en = new IntlMessageFormat(
    [{ type: 0, value: 'Mark as unread' }],
    'en',
);

export function mark_as_unread(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _mark_as_unread_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _mark_as_unread_en.format(args) as unknown as string;
    }

    return _mark_as_unread_fr.format(args) as unknown as string;
}

const _add_participant_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Ajouter un membre' }],
    'fr',
);

const _add_participant_en = new IntlMessageFormat(
    [{ type: 0, value: 'Add member' }],
    'en',
);

export function add_participant(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _add_participant_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _add_participant_en.format(args) as unknown as string;
    }

    return _add_participant_fr.format(args) as unknown as string;
}

const _add_participant_to_the_discussion_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Ajouter un participant dans la discussion' }],
    'fr',
);

const _add_participant_to_the_discussion_en = new IntlMessageFormat(
    [{ type: 0, value: 'Add participant to the discussion' }],
    'en',
);

export function add_participant_to_the_discussion(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _add_participant_to_the_discussion_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _add_participant_to_the_discussion_en.format(args) as unknown as string;
    }

    return _add_participant_to_the_discussion_fr.format(args) as unknown as string;
}

const _button_image_fr = new IntlMessageFormat([{ type: 0, value: 'Image' }], 'fr');

const _button_image_en = new IntlMessageFormat([{ type: 0, value: 'Image' }], 'en');

export function button_image(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _button_image_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _button_image_en.format(args) as unknown as string;
    }

    return _button_image_fr.format(args) as unknown as string;
}

const _button_file_fr = new IntlMessageFormat([{ type: 0, value: 'Fichier' }], 'fr');

const _button_file_en = new IntlMessageFormat([{ type: 0, value: 'File' }], 'en');

export function button_file(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _button_file_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _button_file_en.format(args) as unknown as string;
    }

    return _button_file_fr.format(args) as unknown as string;
}

const _attach_images_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Attacher des images' }],
    'fr',
);

const _attach_images_en = new IntlMessageFormat(
    [{ type: 0, value: 'Attach images' }],
    'en',
);

export function attach_images(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _attach_images_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _attach_images_en.format(args) as unknown as string;
    }

    return _attach_images_fr.format(args) as unknown as string;
}

const _attach_files_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Attacher des fichiers' }],
    'fr',
);

const _attach_files_en = new IntlMessageFormat(
    [{ type: 0, value: 'Attach files' }],
    'en',
);

export function attach_files(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _attach_files_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _attach_files_en.format(args) as unknown as string;
    }

    return _attach_files_fr.format(args) as unknown as string;
}

const _x_participants_fr = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'count',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: ' participant' }] },
                other: { value: [{ type: 7 }, { type: 0, value: ' participants' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
        { type: 0, value: '\n' },
    ],
    'fr',
);

const _x_participants_en = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'count',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: ' participant' }] },
                other: { value: [{ type: 7 }, { type: 0, value: ' participants' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
        { type: 0, value: '\n' },
    ],
    'en',
);

export function x_participants(args: { count: number }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _x_participants_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _x_participants_en.format(args) as unknown as string;
    }

    return _x_participants_fr.format(args) as unknown as string;
}

const _all_my_accounts_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Tous mes comptes' }],
    'fr',
);

const _all_my_accounts_en = new IntlMessageFormat(
    [{ type: 0, value: 'All my accounts' }],
    'en',
);

export function all_my_accounts(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _all_my_accounts_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _all_my_accounts_en.format(args) as unknown as string;
    }

    return _all_my_accounts_fr.format(args) as unknown as string;
}

const _contact_request_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Demande de contact' }],
    'fr',
);

const _contact_request_en = new IntlMessageFormat(
    [{ type: 0, value: 'Contact request' }],
    'en',
);

export function contact_request(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _contact_request_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _contact_request_en.format(args) as unknown as string;
    }

    return _contact_request_fr.format(args) as unknown as string;
}

const _delete_thread_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Supprimer la discussion' }],
    'fr',
);

const _delete_thread_en = new IntlMessageFormat(
    [{ type: 0, value: 'Delete discussion' }],
    'en',
);

export function delete_thread(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _delete_thread_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _delete_thread_en.format(args) as unknown as string;
    }

    return _delete_thread_fr.format(args) as unknown as string;
}

const _message_read_fr = new IntlMessageFormat([{ type: 0, value: 'Message lu' }], 'fr');

const _message_read_en = new IntlMessageFormat(
    [{ type: 0, value: 'Message read' }],
    'en',
);

export function message_read(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _message_read_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _message_read_en.format(args) as unknown as string;
    }

    return _message_read_fr.format(args) as unknown as string;
}

const _reply_fr = new IntlMessageFormat([{ type: 0, value: 'Répondre' }], 'fr');

const _reply_en = new IntlMessageFormat([{ type: 0, value: 'Reply' }], 'en');

export function reply(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _reply_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _reply_en.format(args) as unknown as string;
    }

    return _reply_fr.format(args) as unknown as string;
}

const _delete_the_message_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Supprimer le message' }],
    'fr',
);

const _delete_the_message_en = new IntlMessageFormat(
    [{ type: 0, value: 'Delete the message' }],
    'en',
);

export function delete_the_message(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _delete_the_message_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _delete_the_message_en.format(args) as unknown as string;
    }

    return _delete_the_message_fr.format(args) as unknown as string;
}

const _delete_for_all_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Supprimer pour tous' }],
    'fr',
);

const _delete_for_all_en = new IntlMessageFormat(
    [{ type: 0, value: 'Delete for all' }],
    'en',
);

export function delete_for_all(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _delete_for_all_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _delete_for_all_en.format(args) as unknown as string;
    }

    return _delete_for_all_fr.format(args) as unknown as string;
}

const _flash__marked_as_read_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Marquée comme lue.' }],
    'fr',
);

const _flash__marked_as_read_en = new IntlMessageFormat(
    [{ type: 0, value: 'Marked as read.' }],
    'en',
);

export function flash__marked_as_read(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _flash__marked_as_read_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _flash__marked_as_read_en.format(args) as unknown as string;
    }

    return _flash__marked_as_read_fr.format(args) as unknown as string;
}

const _flash__thread_deleted_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Fil de discussion supprimé.' }],
    'fr',
);

const _flash__thread_deleted_en = new IntlMessageFormat(
    [{ type: 0, value: 'Discussion thread deleted.' }],
    'en',
);

export function flash__thread_deleted(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _flash__thread_deleted_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _flash__thread_deleted_en.format(args) as unknown as string;
    }

    return _flash__thread_deleted_fr.format(args) as unknown as string;
}

const _flash__participant_removed_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Participant retiré avec succès.' }],
    'fr',
);

const _flash__participant_removed_en = new IntlMessageFormat(
    [{ type: 0, value: 'Participant successfully removed.' }],
    'en',
);

export function flash__participant_removed(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _flash__participant_removed_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _flash__participant_removed_en.format(args) as unknown as string;
    }

    return _flash__participant_removed_fr.format(args) as unknown as string;
}

const _flash__message_deleted_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Message supprimé.' }],
    'fr',
);

const _flash__message_deleted_en = new IntlMessageFormat(
    [{ type: 0, value: 'Message deleted.' }],
    'en',
);

export function flash__message_deleted(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _flash__message_deleted_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _flash__message_deleted_en.format(args) as unknown as string;
    }

    return _flash__message_deleted_fr.format(args) as unknown as string;
}

const _flash__message_deleted_for_all_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Message supprimé pour tous.' }],
    'fr',
);

const _flash__message_deleted_for_all_en = new IntlMessageFormat(
    [{ type: 0, value: 'Message deleted for all.' }],
    'en',
);

export function flash__message_deleted_for_all(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _flash__message_deleted_for_all_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _flash__message_deleted_for_all_en.format(args) as unknown as string;
    }

    return _flash__message_deleted_for_all_fr.format(args) as unknown as string;
}

const _confirm__delete_the_discussion_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Supprimer la discussion ?' }],
    'fr',
);

const _confirm__delete_the_discussion_en = new IntlMessageFormat(
    [{ type: 0, value: 'Delete the discussion ?' }],
    'en',
);

export function confirm__delete_the_discussion(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _confirm__delete_the_discussion_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _confirm__delete_the_discussion_en.format(args) as unknown as string;
    }

    return _confirm__delete_the_discussion_fr.format(args) as unknown as string;
}

const _confirm__remove_this_participant_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Voulez-vous vraiment retirer ce participant ?' }],
    'fr',
);

const _confirm__remove_this_participant_en = new IntlMessageFormat(
    [{ type: 0, value: 'Are you sure you want to remove this participant ?' }],
    'en',
);

export function confirm__remove_this_participant(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _confirm__remove_this_participant_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _confirm__remove_this_participant_en.format(args) as unknown as string;
    }

    return _confirm__remove_this_participant_fr.format(args) as unknown as string;
}
